import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27a577ca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "gameArea" }, [
  /*#__PURE__*/_createElementVNode("canvas", { id: "screen" })
], -1))
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cue-power-container" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "cue-power",
    id: "cue-power-id"
  }, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "dot",
      id: "cue-power-dot-id"
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "cue-image" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_game_status = _resolveComponent("game-status")!
  const _component_game_chat = _resolveComponent("game-chat")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_tournament_modal = _resolveComponent("tournament-modal")!
  const _component_sticks_modal = _resolveComponent("sticks-modal")!
  const _component_settings_modal = _resolveComponent("settings-modal")!
  const _component_user_modal = _resolveComponent("user-modal")!
  const _component_big_hit_position_modal = _resolveComponent("big-hit-position-modal")!
  const _component_help_modal = _resolveComponent("help-modal")!
  const _component_donate_modal = _resolveComponent("donate-modal")!
  const _component_invitation_confirm_modal = _resolveComponent("invitation-confirm-modal")!
  const _component_invitation_request_modal = _resolveComponent("invitation-request-modal")!
  const _component_wait_for_opponent_modal = _resolveComponent("wait-for-opponent-modal")!
  const _component_info_modal = _resolveComponent("info-modal")!
  const _component_join_tournament_modal = _resolveComponent("join-tournament-modal")!
  const _component_concede_game_modal = _resolveComponent("concede-game-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_game_status, { gameMode: _ctx.gameMode }, null, 8, ["gameMode"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        ref: "table",
        onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setTableHeight && _ctx.setTableHeight(...args))),
        src: _ctx.gameTable,
        alt: "Table image",
        class: "table game-table"
      }, null, 40, _hoisted_4),
      _createVNode(_component_game_chat, {
        id: "chat",
        class: "chat",
        onSelectOpponent: _ctx.onInitiateGameInvite,
        onUpdateDisplayName: _ctx.onUpdateDisplayName
      }, null, 8, ["onSelectOpponent", "onUpdateDisplayName"])
    ]),
    _createElementVNode("div", {
      style: _normalizeStyle({ height: `${_ctx.tableHeight}px` }),
      class: "side-container"
    }, [
      _createElementVNode("div", {
        class: "white-ball",
        id: "white-ball-id",
        onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseEnter && _ctx.mouseEnter(...args))),
        onMousemove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseMove && _ctx.mouseMove(...args))),
        onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.mouseLeave && _ctx.mouseLeave(...args))),
        onMouseup: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mouseUp && _ctx.mouseUp(...args))),
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.ballMouseDown && _ctx.ballMouseDown(...args)))
      }, [
        _createElementVNode("span", {
          class: "strike-marker-icon",
          id: "strike-marker-icon",
          draggable: "true",
          onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseDown && _ctx.mouseDown(...args)))
        }, " + ", 32)
      ], 32),
      _hoisted_5,
      _createElementVNode("button", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.isSticksShown = true)),
        class: "sticks-button"
      })
    ], 4),
    _createVNode(_component_fa_icon, {
      onClick: _cache[8] || (_cache[8] = ($event: any) => {_ctx.isDonateShown = true; _ctx.gameApplication.getBillardGame().stick.active = false}),
      title: "Donate",
      icon: "heart",
      color: "white",
      size: "2x",
      class: "donate-icon"
    }),
    _createVNode(_component_fa_icon, {
      onClick: _cache[9] || (_cache[9] = ($event: any) => {_ctx.isHelpShown = true; _ctx.gameApplication.getBillardGame().stick.active = false}),
      title: "Help",
      icon: "question",
      color: "white",
      size: "2x",
      class: "help-icon"
    }),
    _createVNode(_component_fa_icon, {
      onClick: _cache[10] || (_cache[10] = ($event: any) => {_ctx.isSettingsShown = true; _ctx.gameApplication.getBillardGame().stick.active = false}),
      title: "Settings",
      icon: "cog",
      color: "white",
      size: "2x",
      class: "settings-icon"
    }),
    (_ctx.isTournamentShown)
      ? (_openBlock(), _createBlock(_component_tournament_modal, {
          key: 0,
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isTournamentShown = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isSticksShown)
      ? (_openBlock(), _createBlock(_component_sticks_modal, {
          key: 1,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isSticksShown = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isSettingsShown)
      ? (_openBlock(), _createBlock(_component_settings_modal, {
          key: 2,
          onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isSettingsShown = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isUserShown)
      ? (_openBlock(), _createBlock(_component_user_modal, {
          key: 3,
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isUserShown = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isBigHitPositionShown)
      ? (_openBlock(), _createBlock(_component_big_hit_position_modal, {
          key: 4,
          onClose: _cache[15] || (_cache[15] = ($event: any) => {_ctx.isBigHitPositionShown = false; this.setBallHitPosition()})
        }))
      : _createCommentVNode("", true),
    (_ctx.isHelpShown)
      ? (_openBlock(), _createBlock(_component_help_modal, {
          key: 5,
          onClose: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isHelpShown = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isDonateShown)
      ? (_openBlock(), _createBlock(_component_donate_modal, {
          key: 6,
          onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.isDonateShown = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.isInvitationConfirmModalShown)
      ? (_openBlock(), _createBlock(_component_invitation_confirm_modal, {
          key: 7,
          onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isInvitationConfirmModalShown = false)),
          inviteePlayerName: _ctx.inviteePlayerName,
          onConfirmInvitePlayer: _ctx.onConfirmInvitePlayer
        }, null, 8, ["inviteePlayerName", "onConfirmInvitePlayer"]))
      : _createCommentVNode("", true),
    (_ctx.isInvitationReqestModalShown)
      ? (_openBlock(), _createBlock(_component_invitation_request_modal, {
          key: 8,
          onClose: _ctx.onCloseInvitationRequestModal
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isWaitForOpponentModalShown)
      ? (_openBlock(), _createBlock(_component_wait_for_opponent_modal, {
          key: 9,
          onClose: _ctx.onCloseWaitForOpponentModal
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isInfoModalShown)
      ? (_openBlock(), _createBlock(_component_info_modal, {
          key: 10,
          onClose: _ctx.onCloseInfoModal
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isJoinTournamentModalShown)
      ? (_openBlock(), _createBlock(_component_join_tournament_modal, {
          key: 11,
          onClose: _ctx.onCloseJoinTournamentModal
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isConcedeGameModalShown)
      ? (_openBlock(), _createBlock(_component_concede_game_modal, {
          key: 12,
          onClose: _ctx.onCloseConcedeGameModal
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}